export enum EventKeys {
    EnterpriseChange = 'EnterpriseChange',
    TaxReturnDeleted = 'ReturnDeleted',
    TaxReturnContextChanged = 'ReturnContextChanged',
    AmountsUpdated = 'AmountChange',
}

export enum SourceKeys {
    TaxReturn = 'TaxReturn',
}

export enum CommandType {
    Execute = 1,
    Print = 2,
}
